import { Validators } from "@angular/forms";

export const environment = {
  production: false,
  baseUrl: 'https://iscrizione-albo.synergica.tech/moduli-api',
  authServerUrl: 'https://auth3.synergica.tech/realms/spid-fake',
  clientId: 'albo-api',
  regione: 'demo',
  regioneLabel: 'Demo',
  extraTitleA: '',
  extraTitleB: '',
  extraTitleAP: '',
  regioneCC: 'DEMO',
  checkProvince: false,
  provincie: [],
  laureaTitleExtra: '',
  abilitazioneTitleExtra: '',
  tesserino: true,
  tesserinoP: ':</b>',
  tesserinoLabel: 'Richiesta Tesserino',
  altroOrdine: true,
  dpExtraInfo: true,
  consensoEmail: true,
  parametriExtra: {
    anagraficaExtra1: '',
    anagraficaExtra2: '',
    contattiExtra: ''
  },
  formConfig: {
    anagrafica: {
      sezioneAlbo: { defaultValue: '', disabled: true, validators: [Validators.required] },
      nome: { defaultValue: '', validators: [Validators.required] },
      cognome: { defaultValue: '', validators: [Validators.required] },
      alias: { defaultValue: '', validators: [Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)] },
      codiceFiscale: { defaultValue: '', validators: [Validators.required, Validators.minLength(16), Validators.maxLength(16)] },
      sesso: { defaultValue: null, validators: [Validators.required] },
      dataNascita: { defaultValue: null, validators: [Validators.required] },
      luogoNascita: { defaultValue: null, validators: [Validators.required] },
      provinciaNascita: { defaultValue: null, validators: [] },
      cittadinanza: { defaultValue: null, validators: [] },
      permessoSoggiorno: { defaultValue: false, disabled: true, validators: [] }
    },
    abitazione: {
      residenzaComune: { defaultValue: null, validators: [] },
      residenzaProvincia: { defaultValue: null, validators: [] },
      residenzaIndirizzo: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[^<>{}\[\]()\";!|\\/?^&%$£:#*]+$/)] },
      residenzaCap: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[0-9]+$/)] },
      residenzaStato: { defaultValue: null, validators: [] },
  
      domicilioFlag: { defaultValue: false, validators: [] },
      domicilioComune: { defaultValue: null, disabled: true, validators: [] },
      domicilioProvincia: { defaultValue: null, disabled: true, validators: [] },
      domicilioIndirizzo: { defaultValue: '', disabled: true, validators: [] },
      domicilioCap: { defaultValue: '', disabled: true, validators: [] },
      domicilioStato: { defaultValue: null, disabled: true, validators: [] },

      corrispondenzaPostale: { defaultValue: 'R', disabled: true, validators: [] }
    },
    documento: {
      tipoDocumento: { defaultValue: null, validators: [Validators.required] },
      numeroDocumento: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)] },
      dataRilascioDocumento: { defaultValue: null, validators: [Validators.required] },
      rilasciatoDa: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)] }
    },
    contatti: {
      email: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)] },
      pec: { defaultValue: '', validators: [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)] },
      telefono: { defaultValue: '', validators: [Validators.pattern(/^[0-9]+$/)] },
      cellulare: { defaultValue: '', validators: [Validators.required, Validators.pattern(/^[0-9]+$/)] }
    },
    laurea_abilitazione: {
      titolo: { defaultValue: null, validators: [Validators.required] },
      laureaUniversita: { defaultValue: null, validators: [Validators.required] },
      laureaCorso: { defaultValue: null, validators: [Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)] },
      laureaData: { defaultValue: null, validators: [Validators.required] },
  
      laureaAbilitante: { defaultValue: false, validators: [] },
      abilitazioneTipo: { defaultValue: null, disabled: true, validators: [] },
      abilitazioneUniversita: { defaultValue: null, disabled: true, validators: [] },
      abilitazioneSessione: { defaultValue: '', disabled: true, validators: [Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)] },
      abilitazioneData: { defaultValue: null, disabled: true, validators: [] }
    },
    dichiarazioni: {
      delittiFlag: { defaultValue: false, validators: [] },
      altriConsigliFlag: { defaultValue: false, validators: [] },
      iscrizioneAltroOrdineFlag: { defaultValue: false, validators: [] },
      regioneAltroOrdine: { defaultValue: null, disabled: true, validators: [] },
      dataCancellazioneAltroOrdine: { defaultValue: null, disabled: true, validators: [] },
      dipendentePubblico: { defaultValue: false, validators: [] },
      dipendentePubblicoPresso: { defaultValue: '', disabled: true, validators: [] },
      dipendentePubblicoRuolo: { defaultValue: '', disabled: true, validators: [] },
      dipendentePubblicoSede: { defaultValue: '', disabled: true, validators: [] },
      dipendentePubblicoTempo: { defaultValue: null, disabled: true, validators: [] },
      dipendentePubblicoOre: { defaultValue: null, disabled: true, validators: [Validators.min(1), Validators.max(48)] },
      articolo82: { defaultValue: null, disabled: true, validators: [] },
      autorizzazione: { defaultValue: false, disabled: true, validators: [] }
    },
    allegati: {
      allegatiFile: { defaultValue: false, validators: [] }
    },
    tesserino: {
      tesserino: { defaultValue: false, validators: [] },
      allegatoTesserino: { defaultValue: false, disabled: true, validators: [] }
    },
    trattamentoDati: {
      trattamentoDatiFlag: { defaultValue: false, validators: [] },
      consensoEmailFlag: { defaultValue: false, validators: [] }
    }
  }
}
